import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/sites.js";

export function useSites(options = {}) {
  return useQuery({ queryKey: keys.sites.list, queryFn: api.fetchSites, ...options });
}

export function useSite(id, options = {}) {
  return useQuery({
    queryKey: keys.sites.detail(id),
    queryFn: () => api.fetchSite(id),
    enabled: !!id,
    ...options,
  });
}

export function useSiteDashboard(id, options = {}) {
  return useQuery({
    queryKey: keys.sites.dashboard(id),
    queryFn: () => api.fetchSiteDashboard(id),
    enabled: !!id,
    ...options,
  });
}

export function useQuickSetup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.quickSetup,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.sites.all });
      qc.invalidateQueries({ queryKey: keys.monitors.all });
    },
  });
}

export function useDeleteSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteSite,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.sites.all });
      qc.invalidateQueries({ queryKey: keys.monitors.all });
    },
  });
}
